import React from "react";
import { Component } from "react";
import { HorizontalBarGraph } from "../../../common/graph/bar-graph.component";
//import Select from 'react-select'
import ButtonIcon from "../../../button";

class AdminHorizontalGraph extends Component {
    render(){
        return(
            <div>
                <h1>{this.props.title}</h1>
                {/*<Select id="usageMonthSelect"*/}
                {/*    options={this.props.usageMonthOptions}*/}
                {/*/>*/}
                <div>
                    <ButtonIcon onClick={()=>alert("click")} iconLeft="file-excel" iconSize="17px" customClassName="header-filter-button" labelName="Export to excel"/> 
                </div>
                <HorizontalBarGraph data={this.props.horizontalChart} fill="#0071cc" withMargin={true} /> 
            </div>
        )
    }
}

export default AdminHorizontalGraph;